import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { GraduationCap, ArrowRight, X } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import api from "../lib/api";

const initials = (name) => (name || "?").trim().split(/\s+/).map((n) => n[0]).slice(0, 2).join("").toUpperCase();

const WelcomeBack = () => {
  const { user, loading } = useAuth();
  const [prog, setProg] = useState(null);
  const [hidden, setHidden] = useState(() => sessionStorage.getItem("ffd_wb_hidden") === "1");

  useEffect(() => {
    if (user) api.get("/course/progress").then((r) => setProg(r.data)).catch(() => {});
  }, [user]);

  if (loading || !user || hidden) return null;

  const first = (user.name || "there").split(" ")[0];
  const access = user.course_access || "none";
  const done = prog?.completed?.length || 0;

  let message, cta;
  if (user.role === "admin") { message = "You have full admin access to the course and games."; cta = "Open the course"; }
  else if (access === "full") {
    message = done >= 10 ? "You've completed the course — grab your certificate!" : done > 0 ? `You're ${done}/10 modules in. Pick up where you left off.` : "Your full course is unlocked — let's get started.";
    cta = done >= 10 ? "Get your certificate" : "Resume my course";
  } else if (access === "deposit") { message = "Your deposit is in — pay the balance to unlock the full course."; cta = "Complete enrollment"; }
  else { message = "Ready to become a pro dispatcher? Enroll in the masterclass."; cta = "Explore the course"; }

  const to = access === "full" && done >= 10 ? "/training/certificate" : "/training";

  const dismiss = () => { sessionStorage.setItem("ffd_wb_hidden", "1"); setHidden(true); };

  return (
    <div className="welcome-back" data-testid="welcome-back-banner">
      <div className="container wb-inner">
        <div className="wb-left">
          {user.picture ? <img src={user.picture} alt="" className="wb-avatar" referrerPolicy="no-referrer" /> : <span className="wb-avatar wb-initials">{initials(user.name)}</span>}
          <div className="wb-text"><strong>Welcome back, {first}!</strong> <span>{message}</span></div>
        </div>
        <div className="wb-right">
          {prog && access === "full" && done < 10 && (
            <div className="wb-progress"><div className="wb-progress-bar" style={{ width: `${(done / 10) * 100}%` }} /></div>
          )}
          <Link to={to} className="btn btn-wb" data-testid="welcome-back-resume"><GraduationCap size={15} /> {cta} <ArrowRight size={14} /></Link>
          <button className="wb-close" onClick={dismiss} aria-label="Dismiss" data-testid="welcome-back-close"><X size={16} /></button>
        </div>
      </div>
    </div>
  );
};

export default WelcomeBack;
